/* global Vue */
import 'slick-carousel/slick/slick.min';
import Listings from './vue-components/listings.vue';
import Listingsfilter from './vue-components/listingsfilter.vue';
import Coworkers from './vue-components/coworkers.vue';

const Theme = Theme || (function() {
  return {
    initSlick: function (element, params = {}) {
      let defaultParams = {
        arrows: false,
        dots: true,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: 'linear',
        speed: 1500,
        infinite: true,
        pauseOnHover: false,
        slide: '.slide',
        touchThreshold: 20,
      };
      $.each(params, function (index, value) {
        defaultParams[index] = value;
      });
      if (element.length) {
        $(element).on('init', function(){
          $(window).trigger('resize');
        });
        $(element).slick(defaultParams);
      }
    },
    initVue() {
      //Class for handling vue events
      window.Event = new class {
        constructor() {
          this.vue = new Vue();
        }

        fire(event, data = null) {
          this.vue.$emit(event, data);
        }

        listen(event, callback) {
          this.vue.$on(event, callback);
        }
      };
      const $componentElements = $('.vue-component');
      if($componentElements.length){
        $.each($componentElements, function(){
            new Vue({
                el: this,
                components: {
                  Listings,
                  Listingsfilter,
                  Coworkers,
                }
            });
        });
      }
    },
  };
}());

export default Theme;
